/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Cloud Platform Vagrant Box Registry
 * API for managing Vagrant boxes.
 *
 * The version of the OpenAPI document: 2022-09-30
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { HashicorpCloudVagrant20220930CreateArchitectureResponseFromJSON, HashicorpCloudVagrant20220930DownloadBoxResponseFromJSON, HashicorpCloudVagrant20220930ListArchitecturesResponseFromJSON, HashicorpCloudVagrant20220930ReadArchitectureResponseFromJSON, HashicorpCloudVagrant20220930UpdateArchitectureResponseFromJSON, HashicorpCloudVagrant20220930UploadBoxResponseFromJSON, InlineObject6ToJSON, InlineObject7ToJSON, InlineObject8ToJSON, } from '../models';
/**
 *
 */
export class ArchitectureServiceApi extends runtime.BaseAPI {
    /**
     * CompleteDirectUploadBox is a callback endpoint used to signal than a direct to backend storage upload of Boxfile is finished.
     */
    async completeDirectUploadBoxRaw(requestParameters) {
        if (requestParameters.registry === null || requestParameters.registry === undefined) {
            throw new runtime.RequiredError('registry', 'Required parameter requestParameters.registry was null or undefined when calling completeDirectUploadBox.');
        }
        if (requestParameters.box === null || requestParameters.box === undefined) {
            throw new runtime.RequiredError('box', 'Required parameter requestParameters.box was null or undefined when calling completeDirectUploadBox.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling completeDirectUploadBox.');
        }
        if (requestParameters.provider === null || requestParameters.provider === undefined) {
            throw new runtime.RequiredError('provider', 'Required parameter requestParameters.provider was null or undefined when calling completeDirectUploadBox.');
        }
        if (requestParameters.architecture === null || requestParameters.architecture === undefined) {
            throw new runtime.RequiredError('architecture', 'Required parameter requestParameters.architecture was null or undefined when calling completeDirectUploadBox.');
        }
        if (requestParameters.object === null || requestParameters.object === undefined) {
            throw new runtime.RequiredError('object', 'Required parameter requestParameters.object was null or undefined when calling completeDirectUploadBox.');
        }
        const queryParameters = {};
        if (requestParameters.key !== undefined) {
            queryParameters['key'] = requestParameters.key;
        }
        if (requestParameters.bytes !== undefined) {
            queryParameters['bytes'] = requestParameters.bytes;
        }
        if (requestParameters.success !== undefined) {
            queryParameters['success'] = requestParameters.success;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry/{registry}/boxes/{box}/versions/{version}/providers/{provider}/architectures/{architecture}/direct/complete/{object}`.replace(`{${"registry"}}`, encodeURIComponent(String(requestParameters.registry))).replace(`{${"box"}}`, encodeURIComponent(String(requestParameters.box))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))).replace(`{${"provider"}}`, encodeURIComponent(String(requestParameters.provider))).replace(`{${"architecture"}}`, encodeURIComponent(String(requestParameters.architecture))).replace(`{${"object"}}`, encodeURIComponent(String(requestParameters.object))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * CompleteDirectUploadBox is a callback endpoint used to signal than a direct to backend storage upload of Boxfile is finished.
     */
    async completeDirectUploadBox(registry, box, version, provider, architecture, object, key, bytes, success) {
        const response = await this.completeDirectUploadBoxRaw({ registry: registry, box: box, version: version, provider: provider, architecture: architecture, object: object, key: key, bytes: bytes, success: success });
        return await response.value();
    }
    /**
     * CompleteUploadBox is a callback endpoint used to signal that an upload of Boxfile is finished.
     */
    async completeUploadBoxRaw(requestParameters) {
        if (requestParameters.registry === null || requestParameters.registry === undefined) {
            throw new runtime.RequiredError('registry', 'Required parameter requestParameters.registry was null or undefined when calling completeUploadBox.');
        }
        if (requestParameters.box === null || requestParameters.box === undefined) {
            throw new runtime.RequiredError('box', 'Required parameter requestParameters.box was null or undefined when calling completeUploadBox.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling completeUploadBox.');
        }
        if (requestParameters.provider === null || requestParameters.provider === undefined) {
            throw new runtime.RequiredError('provider', 'Required parameter requestParameters.provider was null or undefined when calling completeUploadBox.');
        }
        if (requestParameters.architecture === null || requestParameters.architecture === undefined) {
            throw new runtime.RequiredError('architecture', 'Required parameter requestParameters.architecture was null or undefined when calling completeUploadBox.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling completeUploadBox.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry/{registry}/boxes/{box}/versions/{version}/providers/{provider}/architectures/{architecture}/complete`.replace(`{${"registry"}}`, encodeURIComponent(String(requestParameters.registry))).replace(`{${"box"}}`, encodeURIComponent(String(requestParameters.box))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))).replace(`{${"provider"}}`, encodeURIComponent(String(requestParameters.provider))).replace(`{${"architecture"}}`, encodeURIComponent(String(requestParameters.architecture))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InlineObject8ToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * CompleteUploadBox is a callback endpoint used to signal that an upload of Boxfile is finished.
     */
    async completeUploadBox(registry, box, version, provider, architecture, body) {
        const response = await this.completeUploadBoxRaw({ registry: registry, box: box, version: version, provider: provider, architecture: architecture, body: body });
        return await response.value();
    }
    /**
     * CreateArchitecture creates a Architecture in the specified Version.
     */
    async createArchitectureRaw(requestParameters) {
        if (requestParameters.registry === null || requestParameters.registry === undefined) {
            throw new runtime.RequiredError('registry', 'Required parameter requestParameters.registry was null or undefined when calling createArchitecture.');
        }
        if (requestParameters.box === null || requestParameters.box === undefined) {
            throw new runtime.RequiredError('box', 'Required parameter requestParameters.box was null or undefined when calling createArchitecture.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling createArchitecture.');
        }
        if (requestParameters.provider === null || requestParameters.provider === undefined) {
            throw new runtime.RequiredError('provider', 'Required parameter requestParameters.provider was null or undefined when calling createArchitecture.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createArchitecture.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry/{registry}/boxes/{box}/versions/{version}/providers/{provider}/architectures`.replace(`{${"registry"}}`, encodeURIComponent(String(requestParameters.registry))).replace(`{${"box"}}`, encodeURIComponent(String(requestParameters.box))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))).replace(`{${"provider"}}`, encodeURIComponent(String(requestParameters.provider))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InlineObject6ToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVagrant20220930CreateArchitectureResponseFromJSON(jsonValue));
    }
    /**
     * CreateArchitecture creates a Architecture in the specified Version.
     */
    async createArchitecture(registry, box, version, provider, body) {
        const response = await this.createArchitectureRaw({ registry: registry, box: box, version: version, provider: provider, body: body });
        return await response.value();
    }
    /**
     * DeleteArchitecture deletes a Architecture. Note that this deletes any box data associated with an Architecture, so use with care.
     */
    async deleteArchitectureRaw(requestParameters) {
        if (requestParameters.registry === null || requestParameters.registry === undefined) {
            throw new runtime.RequiredError('registry', 'Required parameter requestParameters.registry was null or undefined when calling deleteArchitecture.');
        }
        if (requestParameters.box === null || requestParameters.box === undefined) {
            throw new runtime.RequiredError('box', 'Required parameter requestParameters.box was null or undefined when calling deleteArchitecture.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling deleteArchitecture.');
        }
        if (requestParameters.provider === null || requestParameters.provider === undefined) {
            throw new runtime.RequiredError('provider', 'Required parameter requestParameters.provider was null or undefined when calling deleteArchitecture.');
        }
        if (requestParameters.architecture === null || requestParameters.architecture === undefined) {
            throw new runtime.RequiredError('architecture', 'Required parameter requestParameters.architecture was null or undefined when calling deleteArchitecture.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry/{registry}/boxes/{box}/versions/{version}/providers/{provider}/architectures/{architecture}`.replace(`{${"registry"}}`, encodeURIComponent(String(requestParameters.registry))).replace(`{${"box"}}`, encodeURIComponent(String(requestParameters.box))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))).replace(`{${"provider"}}`, encodeURIComponent(String(requestParameters.provider))).replace(`{${"architecture"}}`, encodeURIComponent(String(requestParameters.architecture))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * DeleteArchitecture deletes a Architecture. Note that this deletes any box data associated with an Architecture, so use with care.
     */
    async deleteArchitecture(registry, box, version, provider, architecture) {
        const response = await this.deleteArchitectureRaw({ registry: registry, box: box, version: version, provider: provider, architecture: architecture });
        return await response.value();
    }
    /**
     * DirectUploadBox initiates the upload of a single hosted Boxfile directly to the backend storage. The service will return details that can be used to upload the data over HTTP.
     */
    async directUploadBoxRaw(requestParameters) {
        if (requestParameters.registry === null || requestParameters.registry === undefined) {
            throw new runtime.RequiredError('registry', 'Required parameter requestParameters.registry was null or undefined when calling directUploadBox.');
        }
        if (requestParameters.box === null || requestParameters.box === undefined) {
            throw new runtime.RequiredError('box', 'Required parameter requestParameters.box was null or undefined when calling directUploadBox.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling directUploadBox.');
        }
        if (requestParameters.provider === null || requestParameters.provider === undefined) {
            throw new runtime.RequiredError('provider', 'Required parameter requestParameters.provider was null or undefined when calling directUploadBox.');
        }
        if (requestParameters.architecture === null || requestParameters.architecture === undefined) {
            throw new runtime.RequiredError('architecture', 'Required parameter requestParameters.architecture was null or undefined when calling directUploadBox.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry/{registry}/boxes/{box}/versions/{version}/providers/{provider}/architectures/{architecture}/direct/upload`.replace(`{${"registry"}}`, encodeURIComponent(String(requestParameters.registry))).replace(`{${"box"}}`, encodeURIComponent(String(requestParameters.box))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))).replace(`{${"provider"}}`, encodeURIComponent(String(requestParameters.provider))).replace(`{${"architecture"}}`, encodeURIComponent(String(requestParameters.architecture))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVagrant20220930UploadBoxResponseFromJSON(jsonValue));
    }
    /**
     * DirectUploadBox initiates the upload of a single hosted Boxfile directly to the backend storage. The service will return details that can be used to upload the data over HTTP.
     */
    async directUploadBox(registry, box, version, provider, architecture) {
        const response = await this.directUploadBoxRaw({ registry: registry, box: box, version: version, provider: provider, architecture: architecture });
        return await response.value();
    }
    /**
     * For Archivist-hosted Boxfile, this is an atomic call that prepares the Provider for download from the object storage. For externally-hosted Boxfiles, this is simply a pass-through to the external download data supplied in the record.
     * Download initiates a Boxfile download.
     */
    async downloadBoxRaw(requestParameters) {
        if (requestParameters.registry === null || requestParameters.registry === undefined) {
            throw new runtime.RequiredError('registry', 'Required parameter requestParameters.registry was null or undefined when calling downloadBox.');
        }
        if (requestParameters.box === null || requestParameters.box === undefined) {
            throw new runtime.RequiredError('box', 'Required parameter requestParameters.box was null or undefined when calling downloadBox.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling downloadBox.');
        }
        if (requestParameters.provider === null || requestParameters.provider === undefined) {
            throw new runtime.RequiredError('provider', 'Required parameter requestParameters.provider was null or undefined when calling downloadBox.');
        }
        if (requestParameters.architecture === null || requestParameters.architecture === undefined) {
            throw new runtime.RequiredError('architecture', 'Required parameter requestParameters.architecture was null or undefined when calling downloadBox.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry/{registry}/boxes/{box}/versions/{version}/providers/{provider}/architectures/{architecture}/download`.replace(`{${"registry"}}`, encodeURIComponent(String(requestParameters.registry))).replace(`{${"box"}}`, encodeURIComponent(String(requestParameters.box))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))).replace(`{${"provider"}}`, encodeURIComponent(String(requestParameters.provider))).replace(`{${"architecture"}}`, encodeURIComponent(String(requestParameters.architecture))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVagrant20220930DownloadBoxResponseFromJSON(jsonValue));
    }
    /**
     * For Archivist-hosted Boxfile, this is an atomic call that prepares the Provider for download from the object storage. For externally-hosted Boxfiles, this is simply a pass-through to the external download data supplied in the record.
     * Download initiates a Boxfile download.
     */
    async downloadBox(registry, box, version, provider, architecture) {
        const response = await this.downloadBoxRaw({ registry: registry, box: box, version: version, provider: provider, architecture: architecture });
        return await response.value();
    }
    /**
     * ListArchitectures lists all Architectures within a Provider.
     */
    async listArchitecturesRaw(requestParameters) {
        if (requestParameters.registry === null || requestParameters.registry === undefined) {
            throw new runtime.RequiredError('registry', 'Required parameter requestParameters.registry was null or undefined when calling listArchitectures.');
        }
        if (requestParameters.box === null || requestParameters.box === undefined) {
            throw new runtime.RequiredError('box', 'Required parameter requestParameters.box was null or undefined when calling listArchitectures.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling listArchitectures.');
        }
        if (requestParameters.provider === null || requestParameters.provider === undefined) {
            throw new runtime.RequiredError('provider', 'Required parameter requestParameters.provider was null or undefined when calling listArchitectures.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry/{registry}/boxes/{box}/versions/{version}/providers/{provider}/architectures`.replace(`{${"registry"}}`, encodeURIComponent(String(requestParameters.registry))).replace(`{${"box"}}`, encodeURIComponent(String(requestParameters.box))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))).replace(`{${"provider"}}`, encodeURIComponent(String(requestParameters.provider))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVagrant20220930ListArchitecturesResponseFromJSON(jsonValue));
    }
    /**
     * ListArchitectures lists all Architectures within a Provider.
     */
    async listArchitectures(registry, box, version, provider, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listArchitecturesRaw({ registry: registry, box: box, version: version, provider: provider, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     * ReadArchitecture fetches a Architecture for the specified Provider.
     */
    async readArchitectureRaw(requestParameters) {
        if (requestParameters.registry === null || requestParameters.registry === undefined) {
            throw new runtime.RequiredError('registry', 'Required parameter requestParameters.registry was null or undefined when calling readArchitecture.');
        }
        if (requestParameters.box === null || requestParameters.box === undefined) {
            throw new runtime.RequiredError('box', 'Required parameter requestParameters.box was null or undefined when calling readArchitecture.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling readArchitecture.');
        }
        if (requestParameters.provider === null || requestParameters.provider === undefined) {
            throw new runtime.RequiredError('provider', 'Required parameter requestParameters.provider was null or undefined when calling readArchitecture.');
        }
        if (requestParameters.architecture === null || requestParameters.architecture === undefined) {
            throw new runtime.RequiredError('architecture', 'Required parameter requestParameters.architecture was null or undefined when calling readArchitecture.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry/{registry}/boxes/{box}/versions/{version}/providers/{provider}/architectures/{architecture}`.replace(`{${"registry"}}`, encodeURIComponent(String(requestParameters.registry))).replace(`{${"box"}}`, encodeURIComponent(String(requestParameters.box))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))).replace(`{${"provider"}}`, encodeURIComponent(String(requestParameters.provider))).replace(`{${"architecture"}}`, encodeURIComponent(String(requestParameters.architecture))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVagrant20220930ReadArchitectureResponseFromJSON(jsonValue));
    }
    /**
     * ReadArchitecture fetches a Architecture for the specified Provider.
     */
    async readArchitecture(registry, box, version, provider, architecture) {
        const response = await this.readArchitectureRaw({ registry: registry, box: box, version: version, provider: provider, architecture: architecture });
        return await response.value();
    }
    /**
     * UpdateArchitecture updates details about a specified Architecture.
     */
    async updateArchitectureRaw(requestParameters) {
        if (requestParameters.registry === null || requestParameters.registry === undefined) {
            throw new runtime.RequiredError('registry', 'Required parameter requestParameters.registry was null or undefined when calling updateArchitecture.');
        }
        if (requestParameters.box === null || requestParameters.box === undefined) {
            throw new runtime.RequiredError('box', 'Required parameter requestParameters.box was null or undefined when calling updateArchitecture.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling updateArchitecture.');
        }
        if (requestParameters.provider === null || requestParameters.provider === undefined) {
            throw new runtime.RequiredError('provider', 'Required parameter requestParameters.provider was null or undefined when calling updateArchitecture.');
        }
        if (requestParameters.architecture === null || requestParameters.architecture === undefined) {
            throw new runtime.RequiredError('architecture', 'Required parameter requestParameters.architecture was null or undefined when calling updateArchitecture.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateArchitecture.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry/{registry}/boxes/{box}/versions/{version}/providers/{provider}/architectures/{architecture}`.replace(`{${"registry"}}`, encodeURIComponent(String(requestParameters.registry))).replace(`{${"box"}}`, encodeURIComponent(String(requestParameters.box))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))).replace(`{${"provider"}}`, encodeURIComponent(String(requestParameters.provider))).replace(`{${"architecture"}}`, encodeURIComponent(String(requestParameters.architecture))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: InlineObject7ToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVagrant20220930UpdateArchitectureResponseFromJSON(jsonValue));
    }
    /**
     * UpdateArchitecture updates details about a specified Architecture.
     */
    async updateArchitecture(registry, box, version, provider, architecture, body) {
        const response = await this.updateArchitectureRaw({ registry: registry, box: box, version: version, provider: provider, architecture: architecture, body: body });
        return await response.value();
    }
    /**
     * Overwrite is permitted; old/existing data for a particular Architecture will be replaced with data from a new successful upload for that same Architecture.
     * UploadBox initiates the upload of a single hosted Boxfile. The service will return details that can be used to upload the data over HTTP.
     */
    async uploadBoxRaw(requestParameters) {
        if (requestParameters.registry === null || requestParameters.registry === undefined) {
            throw new runtime.RequiredError('registry', 'Required parameter requestParameters.registry was null or undefined when calling uploadBox.');
        }
        if (requestParameters.box === null || requestParameters.box === undefined) {
            throw new runtime.RequiredError('box', 'Required parameter requestParameters.box was null or undefined when calling uploadBox.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling uploadBox.');
        }
        if (requestParameters.provider === null || requestParameters.provider === undefined) {
            throw new runtime.RequiredError('provider', 'Required parameter requestParameters.provider was null or undefined when calling uploadBox.');
        }
        if (requestParameters.architecture === null || requestParameters.architecture === undefined) {
            throw new runtime.RequiredError('architecture', 'Required parameter requestParameters.architecture was null or undefined when calling uploadBox.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry/{registry}/boxes/{box}/versions/{version}/providers/{provider}/architectures/{architecture}/upload`.replace(`{${"registry"}}`, encodeURIComponent(String(requestParameters.registry))).replace(`{${"box"}}`, encodeURIComponent(String(requestParameters.box))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))).replace(`{${"provider"}}`, encodeURIComponent(String(requestParameters.provider))).replace(`{${"architecture"}}`, encodeURIComponent(String(requestParameters.architecture))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVagrant20220930UploadBoxResponseFromJSON(jsonValue));
    }
    /**
     * Overwrite is permitted; old/existing data for a particular Architecture will be replaced with data from a new successful upload for that same Architecture.
     * UploadBox initiates the upload of a single hosted Boxfile. The service will return details that can be used to upload the data over HTTP.
     */
    async uploadBox(registry, box, version, provider, architecture) {
        const response = await this.uploadBoxRaw({ registry: registry, box: box, version: version, provider: provider, architecture: architecture });
        return await response.value();
    }
}
